<template>
    <div class="mt-4 pb-4" :class="{ 'border-b' : !last }">
        <div class="text-sm text-gray-600">{{ title }}</div>
        <div class="mt-2">
            <slot></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "FilterCategory",
        props: ['title', 'last']
    }
</script>

<style scoped>

</style>